'use client';

import { useLiveQuery } from '@sanity/preview-kit';
import { defaultLanguage } from '@stereoagency/constants';
import { eventByIdQuery } from './eventQuery';
import EventPage from './EventPage.client';
import { findInKeyArray } from '@/utils';
import { PageSections } from '@/components/layout';

interface Props {
  id: string;
  lang: string;
}

export default function DraftModeEventPage({ id, lang }: Props) {
  const [data] = useLiveQuery<(typeof eventByIdQuery)[1] | null>(
    null,
    eventByIdQuery[0],
    { id }
  );

  if (data == null) {
    return null;
  }

  const content = data.content
    ? findInKeyArray(data.content, [lang, defaultLanguage.id])
    : null;

  return (
    <EventPage
      lang={lang}
      event={{ ...data, upcomingEvents: [] }}
      eventContent={
        content?.value ? (
          <PageSections isPreview sections={content.value} />
        ) : null
      }
    />
  );
}
